import React from "react";

import {
  AccommodationCardDescription,
  AccommodationCardIconContainer,
  AccommodationCardLabel,
  AccommodationCardRoot
} from "./styles";

type TAccommodationCard = React.FC<{
  label: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  selected: boolean;
  readonly?: boolean;
  children?: never;
}>;
export const AccommodationCard: TAccommodationCard = ({
  label,
  description,
  icon,
  onClick,
  selected,
  readonly
}) => {
  return (
    <AccommodationCardRoot
      disabled={readonly}
      $selected={selected}
      onClick={() => onClick()}
    >
      <AccommodationCardLabel>{label}</AccommodationCardLabel>
      <AccommodationCardIconContainer>{icon}</AccommodationCardIconContainer>
      <AccommodationCardDescription>{description}</AccommodationCardDescription>
    </AccommodationCardRoot>
  );
};
